import { __decorate, __metadata } from "tslib";
import { BehaviorSubject } from "rxjs";
import { cloneDeep } from "lodash-es";
import { injectable } from "inversify";
let BaseStore = class BaseStore {
    constructor(defaultValue) {
        this.defaultValue = cloneDeep(defaultValue);
        this.behaviorSubject = new BehaviorSubject(defaultValue);
        this.observable = this.behaviorSubject.asObservable();
    }
    get mutableValue() {
        return this.behaviorSubject.value;
    }
    get value() {
        return this.behaviorSubject.value;
    }
    get value$() {
        return this.observable;
    }
    copy() {
        return cloneDeep(this.mutableValue);
    }
    set(value) {
        this.behaviorSubject.next(value);
        return this.value;
    }
    reset() {
        this.set(this.defaultValue);
        return this.value;
    }
    mutate(mutation) {
        const mutableValue = this.mutableValue;
        const mutated = mutation(mutableValue);
        this.behaviorSubject.next(mutated);
        return this.value;
    }
    async mutateAsync(mutation) {
        const mutableValue = this.mutableValue;
        const mutated = await mutation(mutableValue);
        this.behaviorSubject.next(mutated);
        return this.value;
    }
    notify() {
        this.behaviorSubject.next(this.mutableValue);
    }
};
BaseStore = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Object])
], BaseStore);
export { BaseStore };
let ReadonlyStore = class ReadonlyStore extends BaseStore {
};
ReadonlyStore = __decorate([
    injectable()
], ReadonlyStore);
export { ReadonlyStore };
let MutableStore = class MutableStore extends BaseStore {
    set(value) {
        return super.set(value);
    }
    reset() {
        return super.reset();
    }
    mutate(mutation) {
        return super.mutate(mutation);
    }
    async mutateAsync(mutation) {
        return super.mutateAsync(mutation);
    }
};
MutableStore = __decorate([
    injectable()
], MutableStore);
export { MutableStore };
//# sourceMappingURL=Store.js.map